import { render, staticRenderFns } from "./PainterHomepage.vue?vue&type=template&id=2fbd018a&scoped=true"
import script from "./PainterHomepage.vue?vue&type=script&lang=js"
export * from "./PainterHomepage.vue?vue&type=script&lang=js"
import style0 from "./PainterHomepage.vue?vue&type=style&index=0&id=2fbd018a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd018a",
  null
  
)

export default component.exports